import { FilterDefaults } from "../../models/filter-defaults.model";
import { FilterDisplay } from "../../models/filter-display.enum";
import { FilterOption } from "../../models/filter-option.model";
import { FilterType } from "../../models/filter-type.enum";
import { FilterAdapter } from "../filter-adapter.interface";

export class TreeAdapter implements FilterAdapter <any>{
  readonly type = FilterType.TREE;

  readonly defaults: FilterDefaults = {
    multiple: false,
    searchable: false,
    removableChips: false,
    visible: true,
    disabled: false,
  };

  adapt(array: any[]): FilterOption[] {
    return array.map(element => this.mapElements(element));
  }

  adaptBusqueda(busqueda: boolean): void{
    this.defaults.searchable = busqueda;  
  }
  
  adaptConsolidado(textoConsolidado: string, consolidado: boolean): void {}

  private mapElements(element: any): FilterOption{
    return {
      id: element.name,
      label: element.name,
      value: element,
      selected: element.check,
      children: element.series.map(child => this.mapElements(child))
    };
  }
}